import { createStore } from 'jotai'

export const globalStore = createStore()
